/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import { Injectable } from '@angular/core';
import {AlertController, Toast, ToastController} from "ionic-angular";

/**
 * Injectable to be used to interface with user.
 */
@Injectable()
export class UserInterfacingService {

  private readonly DEFAULT_TOAST_DURATION = 2000;
  private readonly DEFAULT_TOAST_POSITION = 'bottom';
  private readonly TOAST_CLOSE_TEXT = 'OK';
  private readonly TOAST_ERROR_CSS_CLASS = 'error-toast';
  private readonly TOAST_SUCCESS_CSS_CLASS = 'success-toast';
  private readonly TOAST_WARNING_CSS_CLASS = 'warning-toast';

  constructor(private toastCtrl: ToastController, private alertCtrl: AlertController) {
  }

  // region Toasts
  createToast(message: string,
              duration: number = this.DEFAULT_TOAST_DURATION,
              position: string = this.DEFAULT_TOAST_POSITION) : Toast {

    return this.toastCtrl.create({
      message: message,
      duration: duration,
      position: position,
      cssClass: this.TOAST_SUCCESS_CSS_CLASS
    });
  }

  showToastMessage(message: string,
                   duration: number = this.DEFAULT_TOAST_DURATION,
                   position: string = this.DEFAULT_TOAST_POSITION) {

    this.createToast(message, duration, position).present();
  }

  showDismissibleError(message: string, closeHandler?: () => {}) : Toast {
    let toast = this.toastCtrl.create({
      message: message,
      showCloseButton: true,
      closeButtonText: this.TOAST_CLOSE_TEXT,
      cssClass: this.TOAST_ERROR_CSS_CLASS
    });

    if (closeHandler) {
      toast.onDidDismiss(closeHandler);
    }

    toast.present();

    return toast;
  }

  showWarning(message: string, position: string = this.DEFAULT_TOAST_POSITION, closeHandler?: () => {}) {
    let toast = this.toastCtrl.create({
      message: message,
      position: position,
      showCloseButton: true,
      closeButtonText: this.TOAST_CLOSE_TEXT,
      cssClass: this.TOAST_WARNING_CSS_CLASS
    });

    if (closeHandler) {
      toast.onDidDismiss(closeHandler);
    }

    toast.present();

    return toast;
  }
  // endregion

  // region Alerts

  showOkAlert(title: string, message: string) {
    const alert = this.alertCtrl.create({
      title: title,
      subTitle: message,
      buttons: ['Ok']
    });
    alert.present();
    return alert;
  }

  showYesNoPrompt(title: string, message: string,
                  noHandler: (value: any) => boolean | void,
                  yesHandler: (value: any) => boolean | void) {

    this.alertCtrl.create({
      title: title,
      message: message,
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: noHandler
        },
        {
          text: 'Yes',
          handler: yesHandler
        }
      ]
    }).present();
  }

  // endregion

}



// WEBPACK FOOTER //
// ./src/providers/user-interfacing-service/user-interfacing-service.ts